import type { AfterViewInit, ElementRef } from '@angular/core';
import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { decode } from 'blurhash';

@Component({
    selector: 'sp-blurhash-placeholder',
    template: '<canvas #canvas [height]="height" [width]="width"></canvas>',
    styles: [
        `
            :host {
                display: block;
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                border-radius: 4px;
                overflow: hidden;
            }
            canvas {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        `,
    ],
    standalone: true,
})
export class BlurhashPlaceholderComponent implements AfterViewInit {
    @Input() blurHash!: string;
    @Input() width: number = 100;
    @Input() height: number = 100;
    @Input() punch: number = 1;

    @ViewChild('canvas') canvas!: ElementRef<HTMLCanvasElement>;

    ngAfterViewInit(): void {
        if (this.blurHash && this.canvas) {
            this.renderBlurHash();
        }
    }

    private renderBlurHash() {
        try {
            const pixels = decode(this.blurHash, this.width, this.height, this.punch);
            const ctx = this.canvas.nativeElement.getContext('2d');
            if (!ctx) return;

            const imageData = ctx.createImageData(this.width, this.height);
            imageData.data.set(pixels);
            ctx.putImageData(imageData, 0, 0);
        } catch (error) {
            console.log('Error rendering blurhash', error);
        }

        this.canvas.nativeElement.style.width = '100%';
        this.canvas.nativeElement.style.height = '100%';
    }
}
